import {createAsyncThunk} from '@reduxjs/toolkit'

import {PAY} from '@web/core/urls'
import {changeBrowserLocation} from '@web/helpers/browser'

import {NavigationResult, LocationChangeHistoryParam, ThunkApi} from '../interfaces'

const PAY_SECURITY_BLOCK_SETTING_URL = `${PAY}/member/settings/payment-security/block`

/**
 * 페이 멤버십 세팅 페이지로 이동
 */
const navigateToPaymentSecurityBlock = createAsyncThunk<NavigationResult, LocationChangeHistoryParam | void, ThunkApi>(
    'navigateTo/paymentSecurityBlock',
    (args) => {
        const {historyType = 'PUSH'} = args ?? {}

        changeBrowserLocation({url: PAY_SECURITY_BLOCK_SETTING_URL, type: historyType})
        // page 이동은 그 자체로 추가동작 없이 resolve 된다
        return Promise.resolve()
    },
)

export default navigateToPaymentSecurityBlock
